import { render, staticRenderFns } from "./PlayheraShopBanner.vue?vue&type=template&id=011ba8dc&scoped=true&"
import script from "./PlayheraShopBanner.vue?vue&type=script&lang=js&"
export * from "./PlayheraShopBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlayheraShopBanner.vue?vue&type=style&index=0&id=011ba8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ba8dc",
  null
  
)

export default component.exports